module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"major":"Major","minor":"Minor","critical":"Critical"},"zh":{"major":"中度","minor":"轻度","critical":"重度"}}')
  delete Component.options._Ctor
}
